import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a full-length leaning mirror. A 0.5 x 1.7 m glass
// panel in a thin oak frame, tilted back ~8 degrees for the leaning look, with
// a small support strut behind it. Faces +Z.
const FRAME = "#c8975a";
const GLASS = "#9fc4d4";

// 8-degree back tilt (top toward -Z).
const TILT = -0.14;
const COS = Math.cos(TILT);
const SIN = Math.sin(-TILT); // magnitude of the lean

export const standingMirror = defineModel({
  id: "standing-mirror",
  batchId: "modern",
  name: "Standing mirror",
  tags: ["modern", "interior", "decor", "mirror", "bedroom"],
  summary: "A full-length oak-framed mirror leaning back on a strut.",
  tiles: { w: 1, h: 1 },
  footprint: 1.1,
  parts(): Part[] {
    return [
      // oak frame, tilted back so the bottom edge rests on the floor
      { geometry: new THREE.BoxGeometry(0.54, 1.74, 0.04), color: FRAME, position: [0, 0.87 * COS, -0.05], rotation: [TILT, 0, 0] },
      // glass panel proud of the frame along the tilted normal
      { geometry: new THREE.BoxGeometry(0.5, 1.7, 0.02), color: GLASS, position: [0, 0.87 * COS + 0.025 * SIN, -0.05 + 0.025 * COS], rotation: [TILT, 0, 0] },
      // support strut leaning from the frame back down to the floor
      { geometry: new THREE.BoxGeometry(0.05, 1.45, 0.05), color: FRAME, position: [0, 0.7, -0.35], rotation: [0.28, 0, 0] },
    ];
  },
  animations: [],
});
